// ============================================================================
// page-project / gallery.js
// ----------------------------------------------------------------------------
// Project featured-image gallery — Flickity strip with center-aligned cells
// and wrap-around, plus a Magnific Popup lightbox that opens on:
//   - click on any visible cell (Flickity `staticClick` — doesn't fire mid-drag)
//   - click on the dedicated modal-trigger button
//     (`.project--all--gallery--control--modal`)
//
// The lightbox starts on whichever cell is currently centered (modal button)
// or whichever cell was clicked (cell click).
//
// Section #2 (the gallery hero) only renders when the ACF `gallery` repeater
// has items. Section #341 is the alternative hero that renders when the
// gallery is empty — same custom-js was pasted onto it in the source, but
// without a `.project--all--gallery--container` to query, the script would
// crash. We bail out at the top here when the slider element is absent, so
// the same module is safe on either rendering path.
//
// Initial state: the original called `selectCell(1, true, true)` — i.e. land
// on the second cell, no animation, ignore wrap. Preserved here.
//
// Dependencies: jquery + magnific-popup (npm). Install with:
//   npm install jquery magnific-popup
// jQuery is required because Magnific Popup is a jQuery plugin. We bundle our
// own jQuery via the module; WordPress's own jQuery on the page is a separate
// instance and they don't collide — `$.magnificPopup` resolves on the bundled
// copy.
// ============================================================================

import $ from "jquery";
import "magnific-popup";
import "magnific-popup/dist/magnific-popup.css";

import { initCarousels } from "../carousel";

document.addEventListener("DOMContentLoaded", function () {
  const sliderEl = document.querySelector(".project--all--gallery--container");
  if (!sliderEl) return;

  sliderEl.style.display = "block";

  const instances = initCarousels(".project--all--gallery--container", {
    cellAlign: "center",
    contain: true,
    pageDots: false,
    wrapAround: true,
    imagesLoaded: true,
  });
  if (!instances || !instances.length) return;
  const flkty = instances[0].flickity;

  // Match the original: land on cell index 1 with no animation.
  flkty.selectCell(1, true, true);

  // External prev/next buttons (rendered in the section overlay).
  const prev = document.querySelector(
    ".project--all--gallery--control--button.prev",
  );
  const next = document.querySelector(
    ".project--all--gallery--control--button.next",
  );
  if (prev)
    prev.addEventListener("click", function () {
      flkty.previous();
    });
  if (next)
    next.addEventListener("click", function () {
      flkty.next();
    });

  // Build the Magnific Popup item list from the rendered images. We do this
  // ONCE on init — if your gallery is dynamic, move this inside the click
  // handlers so it re-reads on every open.
  const items = Array.from(sliderEl.querySelectorAll("img")).map(
    function (img) {
      return { src: img.currentSrc || img.src };
    },
  );

  function openLightbox(index) {
    $.magnificPopup.open(
      {
        items: items,
        gallery: { enabled: true },
        type: "image",
      },
      index,
    );
  }

  // Dedicated modal-trigger button → open lightbox at current cell.
  const popupTrigger = document.querySelector(
    ".project--all--gallery--control--modal",
  );
  if (popupTrigger) {
    popupTrigger.addEventListener("click", function () {
      openLightbox(flkty.selectedIndex);
    });
  }

  // Clicking a cell (without dragging) → open lightbox at that cell.
  flkty.on("staticClick", function (event, pointer, cellElement, cellIndex) {
    if (cellElement == null) return;
    openLightbox(cellIndex);
  });
});
